/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { SET_BRANDS, SET_MODELS, SET_VERSIONS, SET_BRANCHES, SET_YEARS, SET_SUBVERSIONS, SET_ASSOCIATED_REBUYERS, SET_BRANCH_SELLERS } from 'actions/data';

let initialState = {
  brands: [],
  models: [],
  versions: [],
  branches: [],
  years: [],
  subVersions: [],
  associatedRebuyers: [],
  sellers: []
};

const DataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_BRANDS: {
      const value = action.payload;
      return produce(state, draft => {
        draft.brands = value;
      });
    }
    case SET_MODELS: {
      const value = action.payload;
      return produce(state, draft => {
        draft.models = value;
      });
    }
    case SET_VERSIONS: {
      const value = action.payload;
      return produce(state, draft => {
        draft.versions = value;
      });
    }
    case SET_BRANCHES: {
      const value = action.payload;
      return produce(state, draft => {
        draft.branches = value;
      });
    }
    case SET_YEARS: {
      const value = action.payload;
      return produce(state, draft => {
        draft.years = value;
      });
    }
    case SET_SUBVERSIONS: {
      const value = action.payload;
      return produce(state, draft => {
        draft.subVersions = value;
      });
    }
    case SET_ASSOCIATED_REBUYERS: {
      const value = action.payload;
      return produce(state, draft => {
        draft.associatedRebuyers = value;
      });
    }
    case SET_BRANCH_SELLERS: {
      const value = action.payload;
      return produce(state, draft => {
        draft.sellers = value;
      });
    }


    default: {
      return state;
    }
  }
};

export default DataReducer;
